<template>
   <div>
      <section-definition title="Coach Up" ></section-definition>

      <grade-coach-up
          :coachup_id="coachup_id"
      />


   </div>
</template>

<script>

import GradeCoachUp from "@/views/Curricula/GradeCoachUp";
export default {
   name: "CoachUpContainer",
   components:{GradeCoachUp},
   data(){
      return {
         coachup_id: null,
         // dealer_id:  null,
         // org_id:  null,
         // salesperson_id:  null,
         // manager_id:  null,
      }
   },





   async created() {



      // get url query parameters
      this.coachup_id = this.$route.query.coachup_id;

      if (this.coachup_id == null) this.coachup_id = "620a6e6a57f1d470bc452915 sdf";


      // this.dealer_id = this.$route.query.dealer_id;
      // this.org_id = this.$route.query.org_id;
      // this.salesperson_id = this.$route.query.salesperson_id;
      // this.manager_id = this.$route.query.manager_id;



      // console.log('query params', this.$route.query);


   },
}
</script>

<style scoped>

</style>